import request from '@/utils/request'

const api = {
  list: '/api/retail/supplier/list',
  add: '/api/retail/supplier/add',
  edit: '/api/retail/supplier/edit',
  remove: '/api/retail/supplier/remove',
  saveGoods: '/api/retail/supplier/saveGoods',
  getGoods: '/api/retail/supplier/goods'
}

export default api

export function getSupplierList(parameter) {
  return request({
    url: api.list,
    method: 'get',
    params: parameter
  })
}

export function getAllSuppliers() {
  return request({
    url: api.list + '/all',
    method: 'get'
  })
}

export function listSupplier() {
  return request({
    url: api.list + '/all/simple',
    method: 'get'
  })
}

export function addSupplier(parameter) {
  return request({
    url: api.add,
    method: 'post',
    data: parameter
  })
}

export function editSupplier(parameter) {
  return request({
    url: api.edit,
    method: 'put',
    data: parameter
  })
}

export function removeSupplier(parameter) {
  return request({
    url: api.remove,
    method: 'delete',
    params: parameter
  })
}

/**
 * 保存供应商商品关联
 */
export function saveSupplierGoods(parameter) {
  return request({
    url: api.saveGoods,
    method: 'post',
    params: { supplierId: parameter.supplierId },
    data: parameter.goodsIds
  })
}

/**
 * 获取供应商的商品列表
 */
export function getSupplierGoods(parameter) {
  return request({
    url: api.getGoods,
    method: 'get',
    params: parameter
  })
}

